/**
 * Popup types allowed while the logged-in user's account is deactivated (is_active = false).
 * Must stay in sync with settings flows in PopupManager.
 */
export const INACTIVE_ACCOUNT_ALLOWED_POPUP_TYPES = new Set([
  'settings',
  'settings-account',
  'settings-privacy',
  'settings-notifications',
  'settings-appearance',
  'settings-about',
  'settings-help',
  'settings-billing',
  'account-change-email',
  'account-reset-password',
  'account-change-phone',
  'account-deactivate',
  'account-delete',
]);
